import { GLOBAL_NAME } from '../constants/Globals';
import { UPDATE_CALLEE_PHONE_NUMBER } from '../constants/EventListeners';
export function triggerHostMessageUpdateCalleeNumber(data) {
  if (window[GLOBAL_NAME].triggerEvent) {
    window.hsCalling.triggerEvent({
      event: UPDATE_CALLEE_PHONE_NUMBER,
      data
    });
  }
}